export default __webpack_public_path__ + "static/media/welcome-clients-feedback-bg.d5ce9fa9.jpg";